import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.development';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  private rolesApiUrl = `${environment.apiUrl}/roles`;
  constructor(private http: HttpClient) {}
  // ============================================
  // TRAER ROLES
  //  ===========================================
  obtenerRoles(): Observable<any[]> {
    return this.http.get<any[]>(this.rolesApiUrl);
  }
}
